// extracted by mini-css-extract-plugin
export default {"youtube-social-embed-card":"social-embed-card__youtube-social-embed-card__KHFie","tiktok-social-embed-card":"social-embed-card__tiktok-social-embed-card__EvRJb"};